// app/javascript/controllers/time_ago_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["display"];

  connect() {
    this.updateTimes();
    this.interval = setInterval(() => this.updateTimes(), 60000); // Update every minute
  }

  disconnect() {
    clearInterval(this.interval);
  }

  updateTimes() {
    this.displayTargets.forEach((element) => {
      const timestamp = new Date(element.dataset.timestamp);
      const now = new Date();
      const secondsAgo = Math.floor((now - timestamp) / 1000);
      let text;

      if (secondsAgo < 60) {
        text = I18n.t("datetime.distance_in_words.less_than_x_seconds", { count: 5 });
      } else if (secondsAgo < 3600) {
        const minutes = Math.floor(secondsAgo / 60);
        text = I18n.t("datetime.distance_in_words.x_minutes", { count: minutes });
      } else if (secondsAgo < 86400) {
        const hours = Math.floor(secondsAgo / 3600);
        text = I18n.t("datetime.distance_in_words.about_x_hours", { count: hours });
      } else {
        const days = Math.floor(secondsAgo / 86400);
        text = I18n.t("datetime.distance_in_words.x_days", { count: days });
      }

      element.textContent = `${I18n.t("posted_on")} ${text}`;
    });
  }
}
